import { render, staticRenderFns } from "./object-card-track-controller.vue?vue&type=template&id=52df28d0&scoped=true"
import script from "./object-card-track-controller.vue?vue&type=script&lang=js"
export * from "./object-card-track-controller.vue?vue&type=script&lang=js"
import style0 from "./object-card-track-controller.vue?vue&type=style&index=0&id=52df28d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df28d0",
  null
  
)

export default component.exports